import { t as s } from "./isDefined-fMi6eQ4r.js";
import { f as o } from "./theme-B90C-74v.js";
import { isFunction as c } from "@sniptt/guards";
import { useSyncExternalStore as d } from "react";
import { z as m } from "zod";
var O = (e) => e.replace(/\d+$/, ""), T = (e) => o.find((r) => r === e) ?? "gray", l = (e) => {
  let r = 0;
  for (let a = 0; a < e.length; a++) r = e.charCodeAt(a) + ((r << 5) - r);
  const t = Math.abs(r) % o.length;
  return o[t] ?? "gray";
}, b = ({ string: e, variant: r = 9, theme: t }) => {
  if (r < 1 || r > 12) throw new Error("Variant must be between 1 and 12");
  const a = `${l(e)}${r}`;
  return t.color[a];
}, A = /* @__PURE__ */ m.enum(o), i = () => {
  const e = navigator.userAgent.toLowerCase();
  return e.includes("mac os x") || e.includes("macos") ? "mac" : e.includes("windows") ? "windows" : e.includes("linux") ? "linux" : e.includes("android") ? "android" : e.includes("ios") || e.includes("iphone") || e.includes("ipad") ? "ios" : "unknown";
}, D = () => i() === "mac" ? "⌘" : "Ctrl", x = () => i() === "mac" ? "" : " ", h = "(max-width: 768px)", v = "(hover: none) and (pointer: coarse)", f = {
  getSnapshot: () => !1,
  subscribe: () => () => {
  }
}, n = /* @__PURE__ */ new WeakMap(), M = (e) => ({
  getSnapshot: () => e.matches,
  subscribe: (r) => (e.addEventListener("change", r), () => e.removeEventListener("change", r))
}), S = (e) => {
  const r = n.get(e);
  if (s(r)) return r;
  const t = /* @__PURE__ */ new Map();
  return n.set(e, t), t;
}, g = (e) => {
  if (typeof window > "u" || !c(window.matchMedia)) return f;
  const r = S(window.matchMedia), t = r.get(e);
  if (s(t)) return t;
  const a = M(window.matchMedia(e));
  return r.set(e, a), a;
}, p = () => !1, u = (e) => {
  const { subscribe: r, getSnapshot: t } = g(e);
  return d(r, t, p);
}, B = () => u(h), L = () => u(v);
export {
  h as a,
  i as c,
  b as d,
  T as f,
  v as i,
  A as l,
  B as n,
  x as o,
  O as p,
  u as r,
  D as s,
  L as t,
  l as u
};
